module.exports = __webpack_public_path__ + "static/media/alert.dcf09aa4.png";